import React, { useEffect, useRef, useState } from "react"
import { FormControl, FormHelperText, InputLabel, Select, useTheme } from "@material-ui/core"

const labelPrefix = "outline-select-label"

const OutlinedSelect = ({
  id,
  value,
  onChange,
  multiple = false,
  menuPortal = true,
  label,
  children,
  selectProps,
  selectInputProps,
  native = true,
  fullWidth = true,
  helperText,
  ...rest
}) => {
  const priorityLabel = useRef(null)
  const [priorityLabelWidth, setPriorityLabelWidth] = useState(0)
  const theme = useTheme()
  const labelId = useRef(labelPrefix + crypto.randomUUID())

  useEffect(() => {
    setPriorityLabelWidth(priorityLabel.current.offsetWidth)
  }, [])

  return (
    <FormControl variant="outlined" fullWidth={fullWidth} {...rest} id={id ? `${id}-wrapper` : null}>
      <InputLabel ref={priorityLabel} id={labelId.current}>
        {label}
      </InputLabel>
      <Select
        id={id ? `${id}-select` : null}
        labelId={labelId.current}
        required
        native={native}
        value={value}
        onChange={onChange}
        labelWidth={priorityLabelWidth}
        inputProps={{
          name: id,
          id,
          ...selectInputProps
        }}
        MenuProps={
          selectProps?.MenuProps
            ? { ...selectProps.MenuProps }
            : {
                disablePortal: !menuPortal,
                getContentAnchorEl: null,
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                PaperProps: {
                  style: {
                    marginTop: theme.spacing(0.5)
                  }
                }
              }
        }
        multiple={multiple}
        {...selectProps}
      >
        {children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export { OutlinedSelect }
